import CardThumb from '@/molecules/CardThumb';
import ZoomButton from '@/molecules/ZoomButton';
import clx from 'classnames';
import useZoom from 'context/Modal/views/ZoomSlider/hooks';
import React, { ReactNode } from 'react';
import { RARITY_API_REF } from 'types/modifiers/references';
import { LinkType } from 'types/utils';

type MosaicItemProps = {
  children?: ReactNode;
  imagePath?: string | null;
  cardRef: string;
  name?: string;
  className?: string;
  linkProps?: LinkType;
  inMyCollection?: number;
  inMySale?: number;
  extraElement?: (card: ReturnType<typeof useZoom>['card']) => JSX.Element;
  isLoading?: boolean;
  rarity?: keyof typeof RARITY_API_REF;
  isSuspended?: boolean;
  foiled?: boolean;
  isExclusive?: boolean;
  numberCopyAvailable?: number;
};

const MosaicItem = ({
  children,
  className,
  cardRef,
  imagePath,
  name,
  linkProps,
  inMyCollection,
  extraElement,
  rarity,
  isLoading,
  inMySale,
  isSuspended,
  foiled,
  isExclusive,
  numberCopyAvailable,
}: MosaicItemProps) => (
  <div
    className={clx(
      'flex flex-col gap-2 p-2 hover:-translate-y-2 transition duration-quick',
      className,
      isLoading && 'animate-loadingMozaic',
    )}
  >
    <ZoomButton
      cardRef={cardRef}
      className="flex flex-col gap-2 items-center"
      extraElement={extraElement}
      linkProps={linkProps}
    >
      {name && <p className="lg-bold text-center">{name}</p>}
      {imagePath && (
        <CardThumb
          alt=""
          foiled={foiled}
          imagePath={imagePath}
          inMyCollection={inMyCollection}
          inMySale={inMySale}
          isExclusive={isExclusive}
          isSuspended={isSuspended}
          numberCopyAvailable={numberCopyAvailable}
          rarity={rarity}
        />
      )}
    </ZoomButton>
    {children}
  </div>
);

export default React.memo(MosaicItem);
